import React from 'react';

import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider
} from '@spotahome/ui-library';
import { useSoyuzData } from '@spotahome/soyuz/client';

import '@spotahome/landings-common/src/scss/init.scss';

import LoginSignupModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import AppBanner from '@spotahome/landings-common/src/components/AppBanner';

import StaticPage from './components/StaticPage';

const StaticPageContainer = () => {
  const { [StaticPageContainer.NAME]: requestedData } = useSoyuzData();
  const data = requestedData;

  return (
    <CookiesProvider initialCookie={requestedData.initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <StaticPage data={data} />
          <AppBanner deviceType={requestedData.deviceType} />
          <LoginSignupModal />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

StaticPageContainer.NAME = 'StaticPageContainer';

export default StaticPageContainer;
